import React from 'react';
import { Palette } from 'lucide-react';

const StyleSwitcher = ({ currentTheme, onThemeChange }) => {
  // Get theme number from class name (theme-1, theme-2, theme-3)
  const themeNumber = currentTheme.split('-')[1];
  console.log("Theme number is:", themeNumber);

  // Theme names
  const themeNames = {
    'theme-1': 'Neon Vibrant',
    'theme-2': 'Pastel Dream',
    'theme-3': 'Bold Block'
  };

  return React.createElement('div', { className: 'card animate-slide-up' },
    React.createElement('div', {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '16px'
      }
    },
      React.createElement(Palette, { size: 24, color: 'var(--secondary)' }),
      React.createElement('h3', { className: 'subtitle' }, 'Theme Switcher')
    ),
    React.createElement('p', null, 
      'Current theme: ',
      React.createElement('strong', null, themeNames[currentTheme])
    ),
    React.createElement('div', {
      style: {
        display: 'flex',
        gap: '8px',
        marginTop: '16px'
      }
    },
      React.createElement('button', {
        className: `button ${currentTheme === 'theme-1' ? 'active' : ''}`,
        onClick: () => onThemeChange(),
        style: {
          backgroundColor: currentTheme === 'theme-1' ? 'var(--primary)' : 'rgba(var(--primary-rgb), 0.5)'
        }
      }, 'Switch Theme (Alt+Q)')
    ),
    React.createElement('div', {
      style: {
        marginTop: '16px',
        fontSize: '0.8rem',
        opacity: 0.7
      }
    }, 'Press Alt+Q to cycle through themes')
  );
};

export default StyleSwitcher;